import 'bootstrap/dist/css/bootstrap.min.css'
import '../styles/index.scss';


import Sr from 'scrollreveal';
import MoveTo from 'moveto';

Sr().reveal('.appear', {
    reset: true,
    origin: "bottom",
    distance: "20px",
    duration: 500,
    delay: 0,
    rotate: {
        x: 0,
        y: 0,
        z: 0
    },
    opacity: 0,
    scale: .9,
    easing: "cubic-bezier(0.6, 0.2, 0.1, 1)",
    viewFactor: .2,
    viewOffset: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    },
});

const moveTo = new MoveTo();


const navLinks = document.querySelectorAll('#header .col-12 ul li a');

for(const link of navLinks) {
    link.addEventListener('click', (e) => {
        e.preventDefault();
        moveTo.move(document.querySelector(link.getAttribute('href')))
    })
}
